import(/* webpackMode: "eager" */ "/build/4b196749-84e3-46eb-ba1e-3337a7582b6f/src/app/[locale]/(simulation)/simulateur/[root]/page.tsx");
